<div class="row text-black mx-auto p-3 mt-1">
      <div class="col"><img src="assets/Ceeyu.png" width="30" height="30"/></div>
      <div class="text-body  col-md-auto">Welcome to Ceeyu.us. </div>
        <!--div>Build Date:{{currentDateTime}} </div-->
    </div>
    <!--div class="mx-auto justify-content-md-center row mt-1 mb-3"-->
      <!--div class="row mt-3 mb-3">Please note:</div-->
      <div class="text-center mb-3">Our services are available only to few invited organizations.</div>
